interface Props {
  level: string;
  source: string;
  search: string;
  onLevelChange: (v: string) => void;
  onSourceChange: (v: string) => void;
  onSearchChange: (v: string) => void;
}

export function LogToolbar({
  level,
  source,
  search,
  onLevelChange,
  onSourceChange,
  onSearchChange,
}: Props) {
  const selectClass =
    "rounded-[10px] border border-white/[0.055] bg-[var(--iris-bg-2)] px-3 py-[10px] text-[12px] text-[var(--iris-fg-1)] focus:outline-none focus:ring-1 focus:ring-[var(--iris-neon-purple)]/40";

  return (
    <div className="flex gap-3">
      <input
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search by keyword, scraper, error type…"
        className={`flex-1 ${selectClass}`}
      />
      <select value={level} onChange={(e) => onLevelChange(e.target.value)} className={selectClass}>
        <option value="">All Levels</option>
        <option value="error">Error</option>
        <option value="warn">Warning</option>
        <option value="info">Info</option>
      </select>
      <select
        value={source}
        onChange={(e) => onSourceChange(e.target.value)}
        className={selectClass}
      >
        <option value="">All Sources</option>
      </select>
    </div>
  );
}
